<div class="container">
  <div class="row">
    <div class="col-12">
      <lls-image-upload
              #imageUploadComponent
              [max]="1"
              (uploadFinished)="onImageSelected($event)"
              (removed)="onImageRemoved($event)">
      </lls-image-upload>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-end">
    <div class="btn-group row d-flex mr-0 mt-4" role="group" aria-label="Image Modal">
      <div class="d-flex">
        <button type="button" class="btn btn-outline-primary btn-block mr-2" (click)="activeModal.dismiss('Close click')">Cancel</button>
        <button type="button" class="btn btn-primary mr-2" [disabled]="disableSave" (click)="save()">{{ saveBtnLabel }}</button>
      </div>
    </div>
  </div>
</div>